export const colors = {
  black: '#000001',
  white: '#ffffff',
  bg: '#ffffff',
  text: '#000000',
  darkblue: '#03374d',
  red: '#ff0000',
  accentbglight: '#EEEEEE',
  gold: '#e4ceb4'
};

export const fonts = {
  default: 'FuturaStd, sans-serif',
};

export const breakpoints = {
  xs: 360,
  sm: 460,
  md: 768,
  lg: 1024,
  xl: 1200,
  xxl: 1400,
  max: 1860, // max page width + padding
}

export const dimensions = {
  containerPadding: {
    min: 20,
    max: 40,
  },
  headerHeight: {
    desktop: 90,
    mobile: 75
  },
  topPanelHeight: 25,
  mobileMenuBreakpoint: breakpoints.lg,
  baseFontSize: 20.5
};

export const animation = {
  fast: 200,
  slow: 350,
};




// WEBPACK FOOTER //
// ./src/styles/variables.ts